<template>
  <div class="step-progress-bar local-hero">
    <div class="step-wrapper">
      <!-- Step 1 -->
      <div v-if="step1" class="step-number-text" v-translate="{ stepNumber: 1, numberOfSteps: organizationDetails.isTcrOrganization ? 6 : 3 }">
        Step %{stepNumber} of %{numberOfSteps}
      </div>
      <div v-if="step1" class="step-description-text" v-translate>
        Do you qualify for a grant?
      </div>

      <!-- Step 2 -->
      <div v-if="step2" class="step-number-text" v-translate="{ stepNumber: 2, numberOfSteps: organizationDetails.isTcrOrganization ? 6 : 3 }">
        Step %{stepNumber} of %{numberOfSteps}
      </div>
      <div v-if="step2" class="step-description-text" v-translate>
        Make sure you can receive money
      </div>

      <!-- Step 3 -->
      <div v-if="step3" class="step-number-text" v-translate="{ stepNumber: 3, numberOfSteps: organizationDetails.isTcrOrganization ? 6 : 3 }">
        Step %{stepNumber} of %{numberOfSteps}
      </div>
      <div v-if="step3" class="step-description-text" v-translate>Account creation</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'StepProgressBar',
  props: {
    step1: {
      type: Boolean,
    },
    step2: {
      type: Boolean,
    },
    step3: {
      type: Boolean,
    },
  },
  computed: mapState(['organizationDetails', 'organizationCssVars']),
}
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/responsive';

.step-progress-bar {
  display: flex;
  justify-content: center;

  .step-wrapper {
    @include tablet-and-up-screen {
      max-width: 70%;
    }
  }

  .step-number-text {
    font-size: 1.25rem;
    line-height: 1.75rem;

    @include tablet-screen {
    }

    @include desktop-screen {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }

  .step-description-text {
    font-size: 2rem;
    font-weight: bold;
    line-height: 2.5rem;

    @include tablet-screen {
      font-size: 2.25rem;
      line-height: 2.8rem;
    }

    @include desktop-screen {
      font-size: 3rem;
      line-height: 3.75rem;
    }
  }
}
</style>
